import { deserialize, serialize } from "serializr";

import _axiosInstance from "../../interceptor/_axiosInstance";

import { FilterLeaderboard } from "../../models/LeaderboardModel/Leaderboard.model";
import { TeacherActivityModel } from "../../models/ReportsModel/activity.model";

import { TEACHER_ACTIVITY_SUMMARY,DOWNLOAD_TEACHER_ACTIVITY_SUMMARY  } from "../../routes/routeConstants/apiRoutes";
import { defaultFilterReports } from "../../shared/utils/filter";


export default class TeacherReportsService {

    static fetchTeacherActivitySummary(
        data: FilterLeaderboard,
        onSuccess: (data: TeacherActivityModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterLeaderboard, { ...defaultFilterReports, ...data })
        delete payload.type;
        return _axiosInstance.get(TEACHER_ACTIVITY_SUMMARY, { params: payload })
            .then(response => {
                const data = deserialize(TeacherActivityModel, response?.["data"]) as TeacherActivityModel[];
                onSuccess(data);
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }

    static downloadTeacherActivitySummary(
        data: FilterLeaderboard,
        onSuccess: (value: any) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterLeaderboard, { ...defaultFilterReports, ...data })
        delete payload.type;
        return _axiosInstance.get(DOWNLOAD_TEACHER_ACTIVITY_SUMMARY, { params: payload })
            .then((response) => new Blob([response.data]))
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `Report.csv`,
                );
                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode?.removeChild(link);

                onSuccess("Download");
            })
            .catch((e) => {
                onError(e);
            })
            .finally(onFinal);
    }
}